import { Component, OnDestroy } from '@angular/core';

import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';

import { LinkTabs } from '../core/link-tabs/definitions/link-tabs.models';
import { AppState } from '../store/states/app.state';
import { UserState } from '../store/states/user.state';
import { AccountState } from './store/states/account.state';
import { StoreName } from '../store/definitions/store.constants';
import { ACTIONS } from './definitions/actions.enums';
import { LINK_TABS, SINGULAR_LINK_TABS_NAMES, HIDDEN_CREATE_BUTTON_IN_TABS } from './definitions/permissions.constants';
import { UserType } from './definitions/permissions.enums';

import * as AccountActions from './store/actions/account.actions';
import { MatDialog } from '@angular/material/dialog';
import { MassiveActionsDialogComponent } from './modules/accounts/components/massive-actions-dialog/massive-actions-dialog.component';
import { AccountsService } from './services/accounts.service';
import { Config } from './definitions/accounts.models';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnDestroy {
  readonly SINGULAR_NAME = SINGULAR_LINK_TABS_NAMES;
  readonly CREATOR_PATH = ACTIONS.create;
  readonly IS_ADMIN = UserType.admin;
  readonly HIDDEN_CREATE_BUTTON_TABS = HIDDEN_CREATE_BUTTON_IN_TABS;
  LINK_TABS: LinkTabs[];

  type$: Observable<string>;
  isRootPath$: Observable<boolean>;
  account$: Observable<AccountState>;
  userType: string;
  isUserAllowed: boolean;

  destroySubject$ = new Subject<void>();

  constructor(
    private readonly _router: Router,
    private readonly _store: Store<AppState>,
    private readonly _dialog: MatDialog,
    private readonly _accountService: AccountsService
  ) {
    const route$ = this._router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd),
      startWith({ urlAfterRedirects: this._router.url } as NavigationEnd)
    );

    this._store.pipe(select(StoreName.user), takeUntil(this.destroySubject$)).subscribe(({ user_type }: UserState) => {
      this.userType = user_type;
      this.LINK_TABS = LINK_TABS[user_type];
    });

    this.type$ = route$.pipe(map(({ urlAfterRedirects }: NavigationEnd) => urlAfterRedirects.split('/')[2]));

    this.isRootPath$ = route$.pipe(
      map(({ urlAfterRedirects }: NavigationEnd) => urlAfterRedirects.split('/').length === 3)
    );

    this.account$ = this._store.select(StoreName.account);

    this.getConfig();
  }

  ngOnDestroy() {
    this._store.dispatch(AccountActions.set({ payload: { id: null, email: '' } }));
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  massiveActions(): void {
    this._dialog.open(MassiveActionsDialogComponent, {
      maxWidth: '80%',
      width: '650px',
      disableClose: true
    });
  }

  getConfig(): void {
    this._accountService
      .getConfig()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((res: Config) => (this.isUserAllowed = res.massive_actions_accounts?.is_user_allowed));
  }
}
